"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Apple = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M16.9429211,19.3154141 C16.0208195,20.210295 15.0034454,20.0707888 14.0337076,19.6488678 C13.0027231,19.2184403 12.060206,19.1912196 10.9713775,19.6488678 C9.61544578,20.2341131 8.89579821,20.0639837 8.07917686,19.3154141 C3.46866881,14.5688025 4.14918661,7.33830093 9.38917361,7.06609381 C10.6600406,7.13414559 11.5498176,7.76872844 12.2983872,7.82146856 C13.4110338,7.5951964 14.4760441,6.9470032 15.6669503,7.03206792 C17.0977389,7.14775595 18.1678531,7.71258572 18.8823968,8.72825852 C15.9391574,10.4976048 16.6366881,14.3765562 19.340045,15.4653847 C18.7990334,16.8859656 18.1049052,18.2895335 16.9412198,19.3273232 L16.9429211,19.3154141 Z M12.1963095,7.01505498 C12.0585047,4.90544982 13.7683056,3.17012945 15.735002,3 C16.0055079,5.43285111 13.5233192,7.25323621 12.1963095,7.01505498 Z" })));
};
Apple.displayName = 'Apple';
exports.default = Apple;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Apple.js.map